import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=dc847d26&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc847d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc847d26')) {
      api.createRecord('dc847d26', component.options)
    } else {
      api.reload('dc847d26', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=dc847d26&scoped=true&", function () {
      api.rerender('dc847d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hc/contract/edit.vue"
export default component.exports